import React from 'react'
import Skeleton from 'react-loading-skeleton'
import { match, useRouteMatch } from 'react-router-dom'

import { bemJoin } from 'bem-join'

import { CourtCasePaymentEventType, SortDirection } from '@app/graphql/types'
import { useIntl } from '@app/intl/Intl'
import { Text } from '@app/lib/typography/Text/Text'
import { useCourtCasePaymentEventsQuery } from '@app/queries/CourtCasePaymentEvents/CourtCasePaymentEvents.queries'

import { CourtCaseInvoiceItem } from './Components/CourtCaseInvoiceItem/CourtCaseInvoiceItem'

import './styles.scss'

export const CourtCaseInvoiceList = () => {
  const b = bemJoin('court-case-invoice-list')
  const { formatMessage } = useIntl()
  const match: match<{ courtCaseUuid: string }> = useRouteMatch()
  const courtCaseUuid = match.params.courtCaseUuid

  const { data, loading } = useCourtCasePaymentEventsQuery({
    variables: {
      courtCaseUuid,
      filters: { type: { equals: CourtCasePaymentEventType.FirstInstance } },
      sorts: { createdAt: SortDirection.Asc }
    },
    fetchPolicy: 'network-only'
  })

  const paymentEvents = data?.courtCases?.items?.[0]?.paymentEvents?.items || []

  return (
    <div className={b('section')}>
      <Text size='ml' weight='bold'>
        {formatMessage({ id: 'CourtCases.Invoicing.Section.Invoices.List.Title' })}
      </Text>
      {loading ? (
        <Skeleton />
      ) : paymentEvents.length === 0 ? (
        <Text size='md' weight='normal'>
          {formatMessage({ id: 'CourtCases.Invoicing.Section.Invoices.List.Empty' })}
        </Text>
      ) : (
        <div className={b('invoice-container')}>
          {paymentEvents.map((event) => (
            <CourtCaseInvoiceItem key={event.uuid} paymentEvent={event} />
          ))}
        </div>
      )}
    </div>
  )
}
